exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "div {\r\n  padding-bottom:2%;\r\n}\r\n\r\n.closure-detail-section {\r\n  width: 400px;\r\n  margin-top: 20px !important;\r\n  padding-left: 10px;\r\n}\r\n\r\ndiv.flex-container {\r\n  word-wrap: break-word;\r\n}\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();